import type { ReactNode } from 'react';

import styles from './AuthForm.module.css';
import { LoginLayout } from './LoginLayout';

/**
 * Shared auth shell — same split layout and hero as the login screen.
 */
export function AuthLayout({
  title,
  description,
  children,
  footer,
  heroHeadline,
  heroLead,
  scrollableForm = false,
}: {
  title: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
  footer?: ReactNode;
  heroHeadline?: string;
  heroLead?: string;
  scrollableForm?: boolean;
}): React.JSX.Element {
  return (
    <LoginLayout
      title={title}
      subtitle={description}
      heroHeadline={heroHeadline}
      heroLead={heroLead}
      scrollableForm={scrollableForm}
    >
      {children}
      {footer !== undefined && <div className={styles.footerPrompt}>{footer}</div>}
    </LoginLayout>
  );
}
